import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { FormService } from "../../services/form.service";

export interface MovingSize {
	value: number,
	label: string,
	image: string,
}
export type MovingSizes = MovingSize[];

@Component( {
	selector: 'app-moving-size',
	templateUrl: './moving-size.component.html',
	styleUrls: ['./moving-size.component.scss']
} )
export class MovingSizeComponent implements OnInit {

	movingSize!: UntypedFormGroup
	formGroupName: string = 'movingSize'
		// `:{address-label}:Address`;
	private movingSizes: MovingSizes =  [
		// Big to small
		{
			value: 1,
			label: $localize `:{movingSize1}:Complete household`,
			image: 'images:ms-1',
		},
		{
			value: 2,
			label: $localize `:{movingSize2}:Part of household`,
			image: 'images:ms-2',
		},
		{
			value: 3,
			label: $localize `:{movingSize3}:Few pieces of furniture`,
			image: 'images:ms-3',
		},
		{
			value: 4,
			label: $localize `:{movingSize4}:Some boxes or luggage`,
			image: 'images:ms-4',
		},
	];
	private movingSizesBedrooms: MovingSizes = [
		// Big to small
		{
			value: 1,
			label: '3+ bedroom household',
			image: 'images:ms-1-bedrooms',
		},
		{
			value: 2,
			label: '2 bedroom household',
			image: 'images:ms-2-bedrooms',
		},
		{
			value: 3,
			label: '1 bedroom household',
			image: 'images:ms-3-bedrooms',
		},
		{
			value: 4,
			label: 'Some boxes or luggage',
			image: 'images:ms-4-bedrooms',
		},
	];

	constructor( public formService: FormService ) {
	}

	public getMovingSizes(): MovingSizes {

		return this.movingSize.controls['_bedroomsActive'].value ? this.movingSizesBedrooms : this.movingSizes;
	}

	public ngOnInit(): void {

		this.movingSize = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
	}

	ngAfterViewInit() {

		// After view has loaded
	}

	public onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.movingSize) );
	}
}
